import React from 'react';
import { Typography } from '@mui/material';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';
import { sizeToString } from 'shared/lib/utils/utils';

export default function ItemSizeCell({ size }: { size?: number | null }) {
  return (
    <CellContainer sx={{ justifyContent: 'center', flexShrink: 0 }}>
      <Typography
        sx={{ whiteSpace: 'nowrap' }}
        variant="f14"
        color="text.secondary"
      >
        {size ? sizeToString(size) : '—'}
      </Typography>
    </CellContainer>
  );
}
